import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";
import apiFunctions from "../../../api/functions.js"

import { Row, Col, Label, Input, InputGroup, FormFeedback } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaDatePicker from "../../../components/ParadigmaDatePicker/ParadigmaDatePicker";
import ParadigmaCurrencyInput from "../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput";

import moment from 'moment';
import { format, formatCurrency } from '../../../functions/functions';

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            caja_id: null,
            cuenta_id: null,
            tipoMovimiento: 0,
            fecha: moment(),
            monto: '0,00',
            observacion: '',
            postVariables: ['caja_id', 'cuenta_id', 'tipoMovimiento', 'monto', 'cuota', 'observacion'],
            errors: [],
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }


    resetForm() {
        this.setState({
            id: null,
            caja_id: null,
            cuenta_id: null,
            tipoMovimiento: 0,
            fecha: moment(),
            monto: '0,00',
            observacion: '',
            errors: [],
        });
    }

    getData() {
        const { postVariables, fecha } = this.state;
        let data = {};
        postVariables.forEach(x => {
            data[x] = this.state[x];
        });
        data.fecha = fecha.format('YYYY-MM-DDThh:mm');

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState({
                id: data.id,
                caja_id: data.caja ? data.caja.id : null,
                cuenta_id: data.cuenta ? data.cuenta.id : null,
                tipoMovimiento: data.tipoMovimiento,
                fecha: moment(data.fecha),
                monto: data.monto,
                observacion: data.observacion,
            })
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field) {
        let errors = this.state.errors;
        if (errors) return errors[field];
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        let idMovimiento = this.props.multiSelectIDs();

        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Movimiento",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Movimiento ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Movimiento",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Movimiento ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: () => {return (idMovimiento.length>0) ? (idMovimiento[0]) : (false)},
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Movimiento",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: () => {return (idMovimiento.length>0) ? (idMovimiento[0]) : (false)},
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Movimiento",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Movimiento ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: () => {return (idMovimiento.length>0) ? (idMovimiento[0]) : (false)},
            };
        }
    }

    onOpen = () => {
        const {} = this.state;
        apiFunctions.get(api.caja.usuarioCaja, null, null, null, (response) => {
            if(response && response.data && response.data.caja_id){
                this.setState({caja_id: response.data.caja_id});
            }
        });
    }

    onValidation(){
        const { monto } = this.state;
        let error = {};
        let validate = true;

        if (monto<=0){
            error.monto = [{code: "required", detail: "Seleccione un monto"}];
            validate = false;
        }

        this.setState({
            errors: error,
        })
        return validate;
    }

    render() {
        const { caja_id, cuenta_id, tipoMovimiento, fecha, monto, observacion } = this.state;
        let vars = this.modalVars();
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.caja.movimientosCaja : null)}
                submitUrl={(vars.submitType ? api.caja.movimientosCaja : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onOpen={() => this.onOpen()}
                onPreSubmit={() => this.getData()}
                onValidation={() => this.onValidation()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}
            >
                <ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Fecha"}
                    error={() => this.getError('fecha')}
                    inputComponent={
                        <ParadigmaDatePicker
                            disabled={vars.disabled}
                            value={fecha}
                            onChange={data => this.onChangeField('fecha', data)}
                        />
                    }
                />

                <ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Caja"}
                    inputComponent={
                        <ParadigmaAsyncSeeker
                            clearable={false}
                            disabled={vars.disabled}
                            url={api.caja.caja}
                            parameters={{
                                sort:['nombre'],
                                paginationEnabled:false,
                            }}
                            value={caja_id}
                            onChange={(data) => this.onChangeField('caja_id', (data ? data.id : null))}
                        />
                    }
                    error={() => this.getError('caja_id')}
                />

                <ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Cuenta"}
                    inputComponent={
                        <ParadigmaAsyncSeeker
                            clearable={false}
                            disabled={vars.disabled}
                            url={api.caja.cuentas}
                            parameters={{
                                sort:['nombre'],
                                paginationEnabled:false,
                            }}
                            value={cuenta_id}
                            onChange={(data) => {this.onChangeField('cuenta_id', (data ? data.id : null)); 
                                                this.onChangeField('tipoMovimiento', (data ? data.tipoDefecto : tipoDefecto)); 
                                                this.onChangeField('observacion', ((data && observacion=='') ? data.leyenda : observacion));}}
                        />
                    }
                    error={() => this.getError('cuenta_id')}
                />

                <ParadigmaLabeledInput
                    disabled={vars.disabled}
                    md={[3, 9]}
                    classNames={['','']}
                    label={"Tipo Mov."}
                    inputComponent={
                        <ParadigmaAsyncSeeker
                            disabled={vars.disabled}
                            url={undefined}
                            optionDefault={[{nombre: 'Ingreso', id: 0}, {nombre: 'Egreso', id: 1}]}
                            value={tipoMovimiento}
                            onChange={data => (data) ? (this.onChangeField('tipoMovimiento', data.id)) : (this.onChangeField('tipoMovimiento', 0))}
                            clearable={false}
                        />
                    }
                    error={() => this.getError('nombre')}
                />

                <ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Monto"}
                    error={() => this.getError('monto')}
                    inputComponent={
                        <ParadigmaCurrencyInput
                            disabled={vars.disabled}
                            className="form-control monto w-100"
                            value={formatCurrency(monto)}
                            onChange={data => this.onChangeField('monto', data)}
                        />
                    }
                />

                <ParadigmaLabeledInput
                    md={[3, 9]}
                    label={"Observación"}
                    error={() => this.getError('observacion')}
                    value={observacion}
                    onChange={data => this.onChangeField('observacion', data.target.value)}
                    maxLength={500}
                />


            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Caja/MovimientosCajaCuentas/Modal.js